"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var translateXy_1 = __importDefault(require("./translateXy"));
var interpolateRenderPoints = function (renderPoints, element, viewBox, chartXys) {
    return renderPoints.map(function (it, i) {
        return __assign(__assign({}, it), { values: it.values.map(function (it2) { return (__assign(__assign({}, it2), { points: it2.points.map(function (it3) {
                    var xy = translateXy_1.default.toBrowser(it3.dest[0], it3.dest[1], i, element, viewBox, chartXys);
                    return __assign(__assign({}, it3), { dest: [xy[0], xy[1]] });
                }) })); }) });
    });
};
exports.default = interpolateRenderPoints;
